import store from "@/store/index.js";
import djsApi from "./djsApi.js";

const SEND_SYS_SMS = async (obj) => {
    let js = {};
    js["OPER"] = obj.oper
    js["PHONE_NO"] = obj.user_phone

    console.log(js)

    let res = await djsApi.fSmCloudAdminApi({
        methodName: 'SEND_SYS_SMS',
        js,
        mchId: '320250710',
        userId: '320250710',
        signType: 'MD5',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
    });
    return res;
}

const ORG_USER_BAND_INFO = async (obj) => {
    let js = {};
    js["OPER"] = obj.oper
    js["CHG_ORG_ID"] = store.state.djsAdmin.org_id
    js["CHG_USER_ID"] = store.state.djsAdmin.user_id
    js["CHG_USER_NAME"] =  store.state.djsAdmin.user_name
    js["VERIFY_ID"] = obj.verify_id
    js["VERIFY_CODE"] = obj.verify_code
    js["BAND_TYPE"] = obj.band_type
    js["ACCT_ID"] = obj.acct_id
    js["MCH_ID"] = obj.mch_id
    js["USER_ID"] = obj.user_id
    js["REMARK"] = obj.remark

    console.log(js)

    let res = await djsApi.fSmCloudAdminApi({
        methodName: 'ORG_USER_BAND_INFO',
        js,
        mchId: '320250710',
        userId: '320250710',
        signType: 'MD5',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
    });
    return res;
}
const SAAS_MCH_USER_BAND_INFO = async (obj) => {
    let js = {};
    js["OPER"] = obj.oper
    js["CHG_USER_ID"] = store.state.djsAdmin.user_id
    js["CHG_MALL_ID"] = store.state.djsAdmin.mall_id
    js["CHG_USER_NAME"] =  store.state.djsAdmin.user_name
    js["VERIFY_ID"] = obj.verify_id
    js["VERIFY_CODE"] = obj.verify_code
    js["BAND_TYPE"] = obj.band_type
    js["ACCT_ID"] = obj.acct_id
    js["MCH_ID"] = obj.mch_id
    js["USER_ID"] = obj.user_id
    js["REMARK"] = obj.remark

    console.log(js)

    let res = await djsApi.fSmCloudAdminApi({
        methodName: 'SAAS_MCH_USER_BAND_INFO',
        js,
        mchId: '320250710',
        userId: '320250710',
        signType: 'MD5',
        sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
        sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
    });
    return res;
}
export default {
    SEND_SYS_SMS,
    ORG_USER_BAND_INFO,
    SAAS_MCH_USER_BAND_INFO
}


//////////////////
// WEBPACK FOOTER
// ./common/api/smCloudApi.js
// module id = null
// module chunks = 